import { Box, Tabs, Tab, Button } from "@mui/material";
import React, { useState } from "react";
import {
  ECGTab,
  PressureTab,
  SPO2Tab,
  TabPanel,
  TemperatureTab,
  useGetPatientReports,
} from ".";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import BarChartIcon from "@mui/icons-material/BarChart";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import CanvasJS from "@canvasjs/charts";
import {
  generateMixedChart,
  generatePressureChart,
  generateSPO2Chart,
  generateTemperatureChart,
  getPressureLayout,
  getSPO2Layout,
  getTemperatureLayout,
} from "./ViewReport/reportUtils/utils";
import ReactPDF, { PDFDownloadLink, usePDF } from "@react-pdf/renderer";
import getReportPdf from "./ViewReport/ReportPdf";
import SummaryTab from "./Tabs/SummaryTab";
import SummarizeIcon from "@mui/icons-material/Summarize";

export default function TabsView({ patient_id, org_id }) {
  const tabs = [
    {
      label: "Sintesi",
      Component: <SummaryTab patient_id={patient_id} org_id={org_id} />,
      icon: <SummarizeIcon />,
    },
    {
      label: "SPO2",
      Component: <SPO2Tab patient_id={patient_id} />,
      icon: <BarChartIcon />,
    },
    {
      label: "ECG",
      Component: <ECGTab patient_id={patient_id} />,
      icon: <MonitorHeartIcon />,
    },
    {
      label: "Temperatura",
      Component: <TemperatureTab patient_id={patient_id} />,
      icon: <ThermostatIcon />,
    },
    {
      label: "Pressione",
      Component: <PressureTab patient_id={patient_id} />,
      icon: <ShowChartIcon />,
    },
  ];
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="Tab panel">
          {tabs.map((tab) => (
            <Tab
              label={tab.label}
              key={crypto.randomUUID()}
              iconPosition="start"
              icon={tab.icon}
              sx={{
                paddingLeft: "5vmin",
                paddingRight: "5vmin",
              }}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map(({ Component }, i) => (
        <TabPanel value={value} index={i} key={i}>
          {Component}
        </TabPanel>
      ))}
    </Box>
  );
}
